import React from 'react';
import { PaginationButton } from './paginationButton';

const pages = (start, stop) =>
  Array.from({ length: stop - start + 1 }, (value, index) => start + index);

const getPagesToDisplay = (currentPage, totalPages) => {
  var start = 1;

  if (currentPage + 2 > totalPages && totalPages > 4) {
    start = totalPages - 4;
  } else if (currentPage > 3) {
    if (totalPages > 5) {
      start = currentPage - 2;
    } else {
      start = 1;
    }
  }

  var stop = Math.min(start + 4, totalPages);

  return pages(start, stop);
};

const Pagination = ({ currentPage, totalPages, onChangePage }) => {
  const pagesToDisplay = getPagesToDisplay(currentPage, totalPages);

  const showFirstAndLastButton = totalPages > 5;
  const showPrevAndNextButton = totalPages > 1;
  const firstAndPrevButtonDisabled = currentPage === 1;
  const lastAndNextButtonDisabled = currentPage === totalPages;

  const onPageButtonClick = (page) => {
    onChangePage(page);
  };

  const onPrevButtonClick = () => {
    onChangePage(currentPage - 1);
  };

  const onNextButtonClick = () => {
    onChangePage(currentPage + 1);
  };

  const onFirstButtonClick = () => {
    onChangePage(1);
  };

  const onLastButtonClick = () => {
    onChangePage(totalPages);
  };

  return (
    <div className="pagination-container">
      {!showFirstAndLastButton
        ? null
        : PaginationButton(
            '<<',
            onFirstButtonClick,
            firstAndPrevButtonDisabled,
          )}
      {!showPrevAndNextButton
        ? null
        : PaginationButton('<', onPrevButtonClick, firstAndPrevButtonDisabled)}
      {pagesToDisplay.map((page) =>
        PaginationButton(
          page,
          onPageButtonClick,
          false,
          page === currentPage,
          true,
        ),
      )}
      {!showPrevAndNextButton
        ? null
        : PaginationButton('>', onNextButtonClick, lastAndNextButtonDisabled)}
      {!showFirstAndLastButton
        ? null
        : PaginationButton('>>', onLastButtonClick, lastAndNextButtonDisabled)}
    </div>
  );
};

export { Pagination };
